<template>
    <div>
        <div v-if="historyItemsToShow.length > 0 " class="border-top border-bottom">
            <div class="row mt-2"
                 :class="idx == historyItemsToShow.length - 1 ? 'mb-2' : ''"
                 v-for="(itm, idx) in historyItemsToShow"
                 :key="idx">
                <div class="col-5 p-4">
                    <span class="historyText">{{FormatDate(itm.statusDateSet)}}</span>
                </div>
                <div class="col-7 border-left p-4">
                    <span class="historyText">{{itm.statusName}}</span>
                    <div class="w-100">
                        <small class="text-muted">User: {{itm.statusSetByName}}</small>
                    </div>
                </div>
            </div>
            <div v-if="historyItemsToShow && historyItemsToShow.length > 1" class="row">
                <div class="col-12">
                    <a href="javascript:void(0);"
                       @click="showAll = !showAll"
                       class="float-right">{{ showAll == true ? '- Show less' : '+ Show more'}}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { gadgetApiService } from '@/services/gadget-api.service'
    import moment from "moment";

    export default {
        name: 'CustPaymentStatusHistory',
        props: {
            value: { required: true }
        },
        data: () => {
            return {
                showAll: true
            }
        },
        computed: {
            historyItemsToShow() {
                if (this.showAll == true) {
                    return this.value
                } else {
                    return [this.value[0]]
                }
            }
        },
        methods: {
            FormatDate(dte) {
                if (dte) return moment(dte).format("DD/MM/YYYY hh:mm A");

                return "UNAVAILABLE";
            }
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .historyText {
        font-size: 1rem;
        font-weight: 300;
    }
</style>